import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import CancelIcon from '@mui/icons-material/Cancel';
import Box from '@mui/material/Box';
import { isEmpty } from 'lodash-es';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledCancelIcon = /*#__PURE__*/_styled(CancelIcon, {
  shouldForwardProp: isStyledPropsValid,
  target: "ecqhqgy3"
})(_ref => {
  let {
    theme,
    sx
  } = _ref;
  return _objectSpread2({
    position: 'absolute',
    width: '16px',
    height: '16px',
    right: '12px',
    top: '12px',
    cursor: 'pointer',
    color: theme.customColors.grey[700]
  }, sx);
}, "");
const StyledImgUploadContainer = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "ecqhqgy2"
})(_ref2 => {
  let {
    theme,
    isMax,
    width,
    height,
    value,
    uploadImgLoading
  } = _ref2;
  return _objectSpread2({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: uploadImgLoading ? 'default' : 'pointer',
    fontSize: '12px',
    color: theme.customColors.grey[500],
    borderRadius: '3px',
    width,
    height,
    border: isEmpty(value) ? "1px dashed ".concat(theme.customColors.grey[300]) : "1px solid ".concat(theme.customColors.grey[300])
  }, isMax && {
    background: theme.customColors.grey[200],
    cursor: 'default'
  });
}, "");
const StyledPreviewImg = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "ecqhqgy1"
})(_ref3 => {
  let {
    theme,
    previewWidth,
    previewHeight,
    previewBorderRadius
  } = _ref3;
  return {
    width: previewWidth,
    height: previewHeight,
    borderRadius: previewBorderRadius
  };
}, "");
const StyledUploadImgArea = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "ecqhqgy0"
})(_ref4 => {
  let {
    theme,
    isMax
  } = _ref4;
  return _objectSpread2({
    width: '100%',
    height: '100%'
  }, isMax && {
    background: theme.customColors.grey[200]
  });
}, "");
export { StyledCancelIcon, StyledImgUploadContainer, StyledPreviewImg, StyledUploadImgArea };